import { RolePermission } from '../admin-user-role';
export var InvestorInvestmentUploadStatus;
(function (InvestorInvestmentUploadStatus) {
    InvestorInvestmentUploadStatus["Pending"] = "Pending";
    InvestorInvestmentUploadStatus["Processing"] = "Processing";
    InvestorInvestmentUploadStatus["Completed"] = "Completed";
})(InvestorInvestmentUploadStatus || (InvestorInvestmentUploadStatus = {}));
export var IdentifyUploadInvestorMatchStatus;
(function (IdentifyUploadInvestorMatchStatus) {
    IdentifyUploadInvestorMatchStatus["New"] = "New";
    IdentifyUploadInvestorMatchStatus["Existing"] = "Existing";
    IdentifyUploadInvestorMatchStatus["Ambiguous"] = "Ambiguous";
    IdentifyUploadInvestorMatchStatus["Invalid"] = "Invalid";
})(IdentifyUploadInvestorMatchStatus || (IdentifyUploadInvestorMatchStatus = {}));
export var UploadIssueCode;
(function (UploadIssueCode) {
    UploadIssueCode["EmailDobMismatch"] = "EmailDobMismatch";
    UploadIssueCode["PrimaryTaxIdMissing"] = "PrimaryTaxIdMissing";
    UploadIssueCode["TaxResidencyMissing"] = "TaxResidencyMissing";
    UploadIssueCode["LeuTaxResidencyMissing"] = "LeuTaxResidencyMissing";
    UploadIssueCode["PaymentDateMissing"] = "PaymentDateMissing";
    UploadIssueCode["PaidToMissing"] = "PaidToMissing";
    UploadIssueCode["FuturePaymentDate"] = "FuturePaymentDate";
    UploadIssueCode["AdviserMismatch"] = "AdviserMismatch";
    UploadIssueCode["InvestorTrancheFirmMismatch"] = "InvestorTrancheFirmMismatch";
    UploadIssueCode["DuplicateExternalInvestmentId"] = "DuplicateExternalInvestmentId";
    UploadIssueCode["CashBalanceOutOfRange"] = "CashBalanceOutOfRange";
    UploadIssueCode["MissingRequiredField"] = "MissingRequiredField";
    UploadIssueCode["InvalidFieldValue"] = "InvalidFieldValue";
    UploadIssueCode["AmbiguousMatch"] = "AmbiguousMatch";
    UploadIssueCode["MissingEmailForNewInvestor"] = "MissingEmailForNewInvestor";
    UploadIssueCode["PossibleExistingInvestorByEmail"] = "PossibleExistingInvestorByEmail";
    UploadIssueCode["MissingIdentityFields"] = "MissingIdentityFields";
    UploadIssueCode["TaxResidencyMismatch"] = "TaxResidencyMismatch";
    UploadIssueCode["AdviserWillBeAutoInvited"] = "AdviserWillBeAutoInvited";
    UploadIssueCode["TrancheBankDetailsMissing"] = "TrancheBankDetailsMissing";
})(UploadIssueCode || (UploadIssueCode = {}));
export var UploadIssueSeverity;
(function (UploadIssueSeverity) {
    UploadIssueSeverity["Error"] = "Error";
    UploadIssueSeverity["Warning"] = "Warning";
})(UploadIssueSeverity || (UploadIssueSeverity = {}));
export const DateColumnLabels = {
    identity_date: 'Birth/registration date',
    investment_date: 'Investment date',
    payment_date: 'Payment date',
};
export var UploadMode;
(function (UploadMode) {
    UploadMode["Basic"] = "basic";
    UploadMode["Full"] = "full";
})(UploadMode || (UploadMode = {}));
export function getUploadModeFromPermissions(permissions) {
    const hasFull = permissions.includes(RolePermission.UploadInvestorFull);
    return hasFull ? UploadMode.Full : UploadMode.Basic;
}
export const BasicUploadDisallowedColumnIds = [
    'use_cash_balance',
    'cash_balance',
    'performance_fee_template_id',
    'core_fee_template_id',
    'payment_email_status',
    'payment_date',
    'paid_to',
    'payment_reference',
    'new_investor_adviser',
    'new_investor_legal_entity_adviser',
];
//# sourceMappingURL=index.js.map